import { GordonValues, GordonResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// Gordon Growth Model: Price = Dividend per share next year / (required return - growth)
// Here user inputs current dividend 'u' (assume next year ≈ current), required return k% and growth g%.
export function calculateGordon(values: GordonValues, t?: ToolsTranslations['gordon']): GordonResult {
  const { dividendPerShare, requiredReturnPercent, growthPercent } = values;

  const k = requiredReturnPercent / 100;
  const g = growthPercent / 100;

  if (dividendPerShare < 0) return { price: null, isValid: false, message: t?.invalid.dividendPerShare };
  if (k <= 0) return { price: null, isValid: false, message: t?.invalid.requiredReturnPercent };
  if (g < 0) return { price: null, isValid: false, message: t?.invalid.growthPercent };
  if (k <= g) return { price: null, isValid: false, message: t?.invalid.kLessOrEqualG };

  const price = dividendPerShare / (k - g);
  const rounded = Math.round(price * 10) / 10; // one decimal, e.g., 85.7
  if (!isFinite(rounded)) return { price: null, isValid: false, message: t?.invalid.generic };
  return { price: rounded, isValid: true };
}


